import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=45b1291c&scoped=true"
import script from "./CommentForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CommentForm.vue?vue&type=style&index=0&id=45b1291c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1291c",
  null
  
)

export default component.exports